var Artist = {
    resetErrors: function() {
        $.each($('input'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
        $.each($('select'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
    },
    checkInputs: function() {
        let name = $('#name').val().length;
        let location = $('#location').val().length;
        let url = $('#url').val().length;
        let uid = $('#uid').val().length;
        let country = $('#country').val().length;
        let genre = $('#genre').val().length;
        let themes = $('#themes').val().length;
        let started = $('#started').val().length;
        let status = $('#status').val().length;

        if (name > 0 && location > 0 && url > 0 && uid > 0 
            && country > 0 && status > 0) {
            return true;
        } else {
            return false;
        }
    },
    checkEditInputs: function() {
        let name = $('#name').val().length;
        let location = $('#location').val().length;
        let url = $('#url').val().length;
        let uid = $('#uid').val().length;
        let id = $('#id').val().length;
        let approved = $('#approved').val().length;
        let country = $('#country').val().length;
        let genre = $('#genre').val().length;
        let themes = $('#themes').val().length;
        let started = $('#started').val().length;
        let status = $('#status').val().length;
        if (name > 0 && location > 0 && url > 0 && uid > 0 && id > 0 && approved > 0 
            && country > 0 && status > 0) {
            return true;
        } else {
            return false;
        }
    },
    addArtist: function() {
        this.resetErrors();
        this.addArtistPromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html('Thank you for submitting ' + response.data.name + ' to the Codex.  We will review your submission as soon as possible.');
            })
            .catch((error) => {
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    addArtistPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.name = $('#name').val();
            request.location = $('#location').val();
            request.url = $('#url').val();
            request.uid = $('#uid').val();
            request.country = $('#country').val();
            request.genre = $('#genre').val();
            request.themes = $('#themes').val();
            request.started = $('#started').val();
            request.status = $('#status').val();

            let formData = new FormData();
            let logoFile = document.getElementById('logo').files[0];
            let photoFile = document.getElementById('photo').files[0];

            if (document.getElementById('logo').files.length > 0)
                formData.append("logo", logoFile, logoFile.name);
            if (document.getElementById('photo').files.length > 0)
                formData.append("photo", photoFile, photoFile.name);

            formData.append("name", request.name);
            formData.append("location", request.location);
            formData.append("url", request.url);
            formData.append("uid", request.uid);
            formData.append("country", request.country);
            formData.append("genre", request.genre);
            formData.append("themes", request.themes);
            formData.append("started", request.started);
            formData.append("status", request.status);

            window.axios.post('/submit/artist', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    editArtist: function() {
        this.resetErrors();
        this.editArtistPromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html(response.data.name + ' has been edited.');
            })
            .catch((error) => {
                //console.log(error);
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    editArtistPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.name = $('#name').val();
            request.location = $('#location').val();
            request.url = $('#url').val();
            request.uid = $('#uid').val();
            request.id = $('#id').val();
            request.approved = $('#approved').val();
            request.country = $('#country').val();
            request.genre = $('#genre').val();
            request.themes = $('#themes').val();
            request.started = $('#started').val();
            request.status = $('#status').val();

            let formData = new FormData();
            let logoFile = document.getElementById('logo').files[0];
            let photoFile = document.getElementById('photo').files[0];

            if (document.getElementById('logo').files.length > 0)
                formData.append("logo", logoFile, logoFile.name);
            if (document.getElementById('photo').files.length > 0)
                formData.append("photo", photoFile, photoFile.name);

            formData.append("name", request.name);
            formData.append("location", request.location);
            formData.append("url", request.url);
            formData.append("uid", request.uid);
            formData.append("id", request.id);
            formData.append("approved", request.approved);
            formData.append("country", request.country);
            formData.append("genre", request.genre);
            formData.append("themes", request.themes);
            formData.append("started", request.started);
            formData.append("status", request.status);

            window.axios.post('/curator/artist/edit', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

$(document).ready(function() {
    // click add artist
    $('#submitArtist').on('click', function() {
        // check inputs
        if (!Artist.checkInputs())
            return;
        Artist.addArtist();
    });
    // click edit artist
    $('#editArtist').on('click', function() {
        // check inputs
        if (!Artist.checkEditInputs())
            return;
        Artist.editArtist();
    });
    // set the split-panel height
    let panelHeight = window.screen.availHeight * .75;
    $('.split-panel').css({'height': panelHeight})
});